import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

import { type Surface } from '@Types/surface'

export const linkButton = (theme: Theme, surface: Surface): SerializedStyles =>
  css({
    boxShadow: 'none',
    textTransform: 'none',
    ...(surface === 'onPrimary' && {
      color: theme.palette.primary.contrastText,
    }),
  })
